// extracted by mini-css-extract-plugin
export default {"details":"accordion_details__9avFb","summary":"accordion_summary__IfpCc","content":"accordion_content__mqlyp","chevron":"accordion_chevron__iv7nf"};